import { render, staticRenderFns } from "./MyOrderAdd.vue?vue&type=template&id=b5047b0a&scoped=true"
import script from "./MyOrderAdd.vue?vue&type=script&lang=js"
export * from "./MyOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./MyOrderAdd.vue?vue&type=style&index=0&id=b5047b0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5047b0a",
  null
  
)

export default component.exports